export default [
  {
    header: 'Loyalty Management',
  },
  {
    title: 'Transactions',
    route: 'loyalty-transactions',
    icon: 'MailIcon',
  },
  {
    title: 'Vouchers',
    route: 'merchant-vouchers',
    icon: 'FileIcon',
  }
]
